import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["button",
            "dropdown",
            "eventsCount",
            "eventsEmptyState",
            "eventsList",
            "footer",
            "hunterUpdatesCount",
            "hunterUpdatesEmptyState",
            "hunterUpdatesList"]
  }

  connect() {
    this.buttonTarget.classList.remove("is-animated")
  }

  animateBell() {
    var _this = this

    this.buttonTarget.classList.remove("is-animated")

    // Add class that triggers the bell animation
    setTimeout(() => {
      _this.buttonTarget.classList.add("is-animated")
    }, 200)
  }

  decrecementCount(event) {
    let currentCount = parseInt(this.buttonTarget.dataset.notificationsCount)
    currentCount--

    if (currentCount > 99) {
      currentCount = "99+"
    }

    if (currentCount == 0) {
      delete this.buttonTarget.dataset.notificationsCount
    } else {
      this.buttonTarget.dataset.notificationsCount = currentCount.toString()
    }

    if (event.detail.type === "event") {
      this.eventsCountTarget.innerHTML = (parseInt(this.eventsCountTarget.innerHTML) - 1).toString()

      if (parseInt(this.eventsCountTarget.innerHTML) === 0) {
        this.eventsCountTarget.classList.add("d-none")
      }
    } else {
      this.hunterUpdatesCountTarget.innerHTML = (parseInt(this.hunterUpdatesCountTarget.innerHTML) - 1).toString()

      if (parseInt(this.hunterUpdatesCountTarget.innerHTML) === 0) {
        this.hunterUpdatesCountTarget.classList.add("d-none")
      }
    }
  }

  update(event) {
    let currentCount = parseInt(this.buttonTarget.dataset.notificationsCount) || 0
    currentCount++

    if (currentCount > 99) {
      currentCount = "99+"
    }

    this.footerTarget.classList.remove("d-none")

    this.buttonTarget.dataset.notificationsCount = currentCount.toString()

    if (event.detail.type === "event") {
      this.eventsListTarget.classList.remove("d-none")

      if (this.eventsEmptyStateTarget.classList.contains("d-none") === false) {
        this.eventsEmptyStateTarget.classList.add("d-none")
      }

      this.eventsCountTarget.classList.remove("d-none")
      this.eventsCountTarget.innerHTML = (parseInt(this.eventsCountTarget.innerHTML) + 1).toString()
    } else {
      this.hunterUpdatesListTarget.classList.remove("d-none")

      if (this.hunterUpdatesEmptyStateTarget.classList.contains("d-none") === false) {
        this.hunterUpdatesEmptyStateTarget.classList.add("d-none")
      }

      this.hunterUpdatesCountTarget.classList.remove("d-none")
      this.hunterUpdatesCountTarget.innerHTML = (parseInt(this.hunterUpdatesCountTarget.innerHTML) + 1).toString()
    }

    this.animateBell()
  }

  open() {
    if (! this.dropdownTarget.classList.contains("is-open")) {
      App.analytics.track("Open notifications center")
      App.analytics.ga_track("Notifications Center", "Open")
    }

    this.dropdownTarget.classList.toggle("is-open")
    this.dropdownTarget.focus()
  }

  close(e) {
    // This manage the "clickOutside" to close the notifications center when open, the "force" param can be used to
    // force the close from anything inside the notification center
    if (e && e.params.force !== true && (this.dropdownTarget.contains(e.target) || this.buttonTarget.contains(e.target))) {
      return
    }

    this.dropdownTarget.classList.remove("is-open")
  }
}
